module.exports = __webpack_public_path__ + "img/20241215_2.733fabe5.jpg";